module.exports = __webpack_public_path__ + "static/media/39_tn.d9d02df9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/39_tn.jpg
// module id = 252
// module chunks = 0